import React from "react";
import CenterModal from "../../../mobilecomponent/CenterModal";

const Poop1000Modal = ({ showPoop1000 }) => {
  const jangruboy_wow = "/images/mo/jangruboy_wow.svg";
  const closeicon = "/images/mo/closebasic.svg";
  return (
    <CenterModal>
      <img
        src={closeicon}
        alt="closeicon"
        className="cursor-pointer absolute top-0 right-0"
        onClick={showPoop1000}
      />

      <div className="pt-[16px] pb-[8px] flex justify-center items-center">
        <img src={jangruboy_wow} alt="jangruboy_wow" />
      </div>
      <div className="flex flex-col items-center">
        <span className="block">배변량이 많아 주의가 필요해요!</span>
        <span className="block">배변량을 잘 기록해 주세요 :)</span>
      </div>
    </CenterModal>
  );
};

export default Poop1000Modal;
